import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import ModuleCategoryService from "../../services/moduleCategory/ModuleCategoryService";
import { loadingModuleCategoryDropdown } from "../../store/slices/moduleCategory/moduleCategorySlice";

export const useModuleCategory = () => {
  const dispatch: AppDispatch = useDispatch();

  const { moduleCategoryDropdown } = useSelector(
    (state: RootState) => state.moduleCategory
  );

  /**
   * 🔹 Obtiene el listado de categorías de módulos para usar en selects
   */
  const fetchModuleCategoryDropdown = async () => {
    try {
      const response = await ModuleCategoryService.fetchDropdown();
      dispatch(loadingModuleCategoryDropdown(response));
    } catch (error) {
      console.error("Error al cargar las categorías de módulo:", error);
    }
  };

  return {
    moduleCategoryDropdown,
    fetchModuleCategoryDropdown,
  };
};
